module.exports = __webpack_public_path__ + "img/countdown.2dfd8ddd.svg";